AFRAME.registerComponent("persistable", {
  schema: {
    uuid: { type: "string" },
    networkable: { type: "boolean", default: false }
  },
  init() {
    this.el.object3D.type = "Persistable";

    if (this.data.uuid) {
      this.el.object3D.uuid = this.data.uuid;
      this.el.object3D.persistableId = this.data.uuid;
    }
  }
});
